import $ from "jquery";
import datepickerFactory from "jquery-datepicker";
import bootstrap from "bootstrap";
import "select2";

window.getClientRects = function () {
  return { top: 0, left: 0 };
};

window.$ = window.jQuery = $;
datepickerFactory($);

/**
 * Safe Wizard Reclami Initializer
 *
 * Handles deterministic initialization of the wizard module with:
 * - Idempotent execution (runs once)
 * - DOM readiness checking (waits for #modulo-reclami)
 * - Late rendering support (polling with timeout)
 * - Race condition prevention
 *
 * This function can be called multiple times safely - it will only initialize once.
 */
function initWizardReclami() {
  // Guard: prevent multiple initializations
  if (window.__wizardReclamiInitialized) {
    return;
  }

  // Check if root element exists
  const rootElement = document.getElementById("modulo-reclami");

  if (rootElement) {
    // Element exists - proceed with initialization
    initializeWizardModule();
  } else {
    // Element not found - start polling with timeout
    pollForWizardRoot();
  }
}

/**
 * Poll for wizard root element with timeout.
 * Retries every 100ms for up to 5 seconds.
 */
function pollForWizardRoot() {
  const MAX_RETRIES = 50; // 50 * 100ms = 5 seconds
  let retryCount = 0;

  const pollInterval = setInterval(() => {
    retryCount++;

    const rootElement = document.getElementById("modulo-reclami");

    if (rootElement) {
      // Element found - stop polling and initialize
      clearInterval(pollInterval);
      initializeWizardModule();
    } else if (retryCount >= MAX_RETRIES) {
      // Timeout reached - stop polling
      clearInterval(pollInterval);
      console.warn(
        "[Wizard Reclami] Root element #modulo-reclami not found after 5 seconds. Wizard will not initialize."
      );
    }
  }, 100);
}

/**
 * Initialize the wizard module by dynamically importing it.
 * Sets initialization flag and exposes instance to window.
 */
function initializeWizardModule() {
  // Double-check guard (race condition protection)
  if (window.__wizardReclamiInitialized) {
    return;
  }

  // Set flag immediately to prevent concurrent initializations
  window.__wizardReclamiInitialized = true;

  import("./wizard-reclami/main.js")
    .then((wizardModule) => {
      // Wizard module exposes itself to window.wizardReclami during initialization
      // Wait a tick to ensure module has finished exposing itself
      setTimeout(() => {
        if (window.wizardReclami && typeof window.wizardReclami === "object") {
          console.log("[Wizard Reclami] Initialized");
        } else {
          // Fallback: ensure the instance is exposed
          window.wizardReclami = wizardModule.default;
          console.log("[Wizard Reclami] Initialized");
        }
      }, 0);
    })
    .catch((error) => {
      // Reset flag on error to allow retry
      window.__wizardReclamiInitialized = false;
      console.error("[Wizard Reclami] Error loading wizard module:", error);
    });
}

import Swiper from "swiper/bundle";
import UXManager from "./libs/ux.js";
import LazyLoadManager from "./libs/lazyload.js";
import SwiperManager from "./libs/swiper.js";
import QRCodeManager from "./libs/qrcode.js";
import VideoControlsManager from "./libs/videocontrols.js";
import InvieportManager from "./libs/inviewport.js";
import GoogleMapsManager from "./libs/googlemaps.js";
import GoogleMapsAsideManager from "./libs/googlemapsaside.js";
import SearchSystemManager from "./libs/searchsystem.js";
import GeolocationManager from "./libs/geolocator.js";
import FAQManager from "./libs/faq.js";
import ModalizerManager from "./libs/modalizer.js";
import MapManager from "./libs/mapManager.js";
import StickyFilter from "./libs/StickyFilter.js";
import OfferPortalStickyCta from "./libs/OfferPortalStickyCta.js";
import FormStickyCta from "./libs/FormStickyCta.js";
import OfferPortalCtaSync from "./libs/OfferPortalCtaSync.js";

$(document).ready(function () {
  const ux = new UXManager();
  window.ux = ux;

  const body = document.body;
  if (body.dataset.id === "67489fce8bceaf43167ba28f") {
    // Trova tutti gli accordion aperti (Bootstrap 5 usa .collapse.show)
    const openAccordions = document.querySelectorAll(
      ".accordion .collapse.show"
    );
    openAccordions.forEach((el) => {
      // Rimuove la classe 'show' per chiuderli
      el.classList.remove("show");
    });
  }

  $(".select-2").each(function () {
    const $el = $(this);

    // 🔹 Forza l’attributo multiple
    if (!$el.attr("multiple")) {
      $el.attr("multiple", "multiple");
    }

    // 🔹 Inizializza Select2
    $el.select2({
      width: "100%",
      theme: "bootstrap-5",
      placeholder: "Seleziona uno o più valori",
      allowClear: true,
    });
  });

  $(".component.qrcode").each(function () {
    const qr = new QRCodeManager($(this));
  });

  // prima faccio partire gli async che conterranno eventualmente anche dei '.component .swiper'
  $(".async_content_list").each(function () {
    //console.log('MAIN - faccio partire asincrono su', $(this));
    const sma = new SwiperManager($(this), true);
  });

  // poi faccio partire i '.component .swiper' non asincroni
  $(".component .swiper").each(function () {
    //console.log('MAIN - guardo il parent di component', $(this).closest('.component').parent());
    if ($(this).closest(".component").parent().hasClass("async_content_list")) {
      //console.log('MAIN - Blocco perché dentro a un async_content_list', $(this));
    } else {
      //console.log('MAIN - faccio partire sincrono su', $(this));
      const sm = new SwiperManager($(this), false);
    }
  });

  $("video.hascustomcontrols").each(function () {
    const vc = new VideoControlsManager($(this));
  });

  $('[data-role="faq"]').each(function () {
    const fm = new FAQManager($(this));
  });

  $(".modalizer").each(function () {
    const modm = new ModalizerManager($(this));
  });

  $("#map_opener").on("click", () => {
    $("#map_opener").addClass("unshow");
    $("#map_blurr").addClass("unshow");
    $(".component.map.googlemaps").removeClass("unshow");
    $(".component.map.googlemaps").addClass("showed");
    let script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyBAZEkqnfy411LAXw9gHpuq5xDA0KcSpIc&libraries=places&callback=initMap";
    script.async = true;
    window.initMap = function () {
      $(".component.map.googlemaps").each(function () {
        const gmc = new GoogleMapsManager($(this));
      });
    };
    document.body.appendChild(script);
  });

  if ($(".component.map.googlemapsaside").length > 0) {
    window.gmac = new GoogleMapsAsideManager(
      $(".component.map.googlemapsaside")
    );
  }

  window.ll = new LazyLoadManager();
  window.ivm = new InvieportManager();

  setTimeout(function () {
    window.ss = new SearchSystemManager();
  }, 500);

  setTimeout(function () {
    window.glm = new GeolocationManager();
  }, 1000);

  // Initialize StickyFilter for dynamic sticky filter blocks
  window.stickyFilter = new StickyFilter();

  if (
    document.body.classList.contains("offer-portal") ||
    document.body.classList.contains("offer")
  ) {
    window.offerPortalStickyCta = new OfferPortalStickyCta();
  }

  window.formStickyCta = new FormStickyCta();

  if (document.body.classList.contains("offer-portal")) {
    window.offerPortalCtaSync = new OfferPortalCtaSync();
  }

  const syncMenuToggleLabel = (button) => {
    const open = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-label", open ? "Chiudi il menu" : "Apri il menu");
  };

  $(".navbar-toggler").each(function () {
    syncMenuToggleLabel(this);
  });

  $(".navbar-toggler").on("click", function () {
    const button = this;
    $(".navbar-brand svg").addClass("active");
    setTimeout(function () {
      syncMenuToggleLabel(button);
    }, 0);
    setTimeout(function () {
      syncMenuToggleLabel(button);
      if (!$(".navbar-collapse").hasClass("show")) {
        $(".navbar-brand svg").removeClass("active");
      }
    }, 500);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const nav = document.getElementById("navbarNav");
    if (!nav || !nav.classList.contains("show")) return;
    const toggler = document.querySelector(".navbar-toggler");
    if (toggler) toggler.click();
  });

  // Initialize Wizard Reclami (handled by safe initializer)
  initWizardReclami();
});

// Also try initialization immediately (in case DOM is already ready)
// The function is idempotent, so calling it multiple times is safe
initWizardReclami();

if (document.getElementById("pre-email")) {
  document
    .getElementById("pre-email")
    .addEventListener("submit", function (event) {
      event.preventDefault(); // Previene il comportamento predefinito di invio del form

      // Recupera il valore dell'email dal primo form
      const email = document.getElementById("email").value;

      // Popola il campo email del secondo form cercando l'elemento tramite il suo name contact[email]
      document.querySelector("input[name='contact[email]']").value = email;

      // Invia i dati al tuo server (Concrete5)
      inviaDatiAlServer(email);

      // Scrolla fino al secondo form con name demo
      document.querySelector("a[name='demo']").scrollIntoView({
        behavior: "smooth",
      });
    });
}

// Funzione per inviare i dati al server Concrete5
function inviaDatiAlServer(email) {
  // Dati che vuoi inviare
  const data = {
    spreadsheetId: "1FmNYdlntQF99zwkoRVXCGDb6R1AEym1NS2jHuHkOQq4",
    sheetName: "Partial_email",
    data: new Date().toLocaleDateString(), // Data corrente
    ora: new Date().toLocaleTimeString(), // Ora corrente
    pagina_acquisizione: window.location.href, // URL corrente
    utm_source: getUTMParam("utm_source"),
    utm_medium: getUTMParam("utm_medium"),
    utm_campaign: getUTMParam("utm_campaign"),
    email: email,
  };

  // Invia la richiesta al tuo server
  fetch("application/tools/spreadsheet-connector.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((responseData) => {
      if (responseData.success) {
        console.log("Dati inviati con successo:", responseData.data);
      } else {
        console.error("Errore dal server:", responseData.message);
      }
    })
    .catch((error) => {
      console.error("Errore durante l'invio dei dati:", error);
    });
}

// Funzione per recuperare i parametri UTM dalla URL
function getUTMParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  console.log(urlParams.get(param));
  return urlParams.get(param) || ""; // Ritorna vuoto se non presente
}
